module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAA3CAMAAACfBSJ0AAAAUVBMVEXv7+/v7+/v7+/v7+/v7+/v7+/v7+9HcEzv7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7++Hh4e90rRSAAAAGnRSTlO4AklMYmEBAFdWLFyjgH9KpaSFKAknCAdIRxUidogAAACRSURBVEjH7da7EoMwDETRtR1kwBgSHoHk/z+UKFCmsDSThtH2p9rmIvJo8U3Z/EJfAVahQ/m6QIdbe8jWP9lRhnSZPi5AvhDhHgp3d2ihWQuvch61yiWlq8yZM3cJ9/6xfzr7wZy5a7qk7hdtL2n7TNuD0Y1iNjru3Vnau3k++/ol6uvt7GuW05BuJUvDdPT8DqC6C9TvubyKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/styles/common/img/minus.png
// module id = ZJeT
// module chunks = 37